import {Icon, MenuListItem, Text} from '@albert-io/atomic';
import React from 'react';
import {Link} from 'react-router';

interface SubjectMenuSectionItemProps {
  onClick: () => void;
  text: string;
  isSelected: boolean;
  to?: string;
  sectionProps?: Record<string, any>;
  'data-testid'?: string;
}

export const SubjectMenuSectionItem = ({
  onClick,
  text,
  isSelected,
  to,
  sectionProps = {},
  'data-testid': dataTestId
}: SubjectMenuSectionItemProps) => {
  return (
    <div className='gap-x1 flex flex-col'>
      <MenuListItem
        as={Link}
        className='border-b-border-primary p-x2! flex justify-between! rounded-none border-b'
        onClick={onClick}
        to={to}
        selected={isSelected}
        data-testid={dataTestId}
      >
        <div className='gap-x1 flex items-center'>
          {sectionProps.leftIcon && (
            <Icon
              icon={sectionProps.leftIcon}
              color={isSelected ? 'brand' : 'primary'}
              iconStyle='regular'
            />
          )}
          <Text bold size='s' color={isSelected ? 'brand' : 'primary'}>
            {text}
          </Text>
        </div>
        {sectionProps.rightContent && sectionProps.rightContent}
      </MenuListItem>
      {sectionProps.children && (
        <div className='subject-menu-section__children'>{sectionProps.children}</div>
      )}
    </div>
  );
};
